import { render, staticRenderFns } from "./contractChangeAuditHistoryOrdersList.vue?vue&type=template&id=71c7f3ae&scoped=true"
import script from "./contractChangeAuditHistoryOrdersList.vue?vue&type=script&lang=js"
export * from "./contractChangeAuditHistoryOrdersList.vue?vue&type=script&lang=js"
import style0 from "./contractChangeAuditHistoryOrdersList.vue?vue&type=style&index=0&id=71c7f3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7f3ae",
  null
  
)

export default component.exports